import { Box, Typography } from '@mui/material';
import { NoItemsIcon } from '@ankr.com/ui';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { codeSnippetPlaceholderTranslation } from './translation';
import { useCodeSnippetPlaceholderStyles } from './useCodeSnippetPlaceholderStyles';

export const CodeSnippetPlaceholder = () => {
  const { classes } = useCodeSnippetPlaceholderStyles();

  const { keys, t } = useTranslation(codeSnippetPlaceholderTranslation);

  return (
    <Box className={classes.root}>
      <NoItemsIcon className={classes.icon} />
      <Typography variant="body3" color="textSecondary" mt={1}>
        {t(keys.noContent)}
      </Typography>
    </Box>
  );
};
